<div class="detail">
  <button type="button" class="detail-close" (click)="onClose()" [attr.aria-label]="'common_btn_close' | translate">
    <mat-icon>close</mat-icon>
  </button>

  <ng-container *ngIf="detail">
    <div class="detail-header">
      <h4 class="detail-title">{{ detail.subject }}</h4>
      <span class="status-badge" [class.status-sent]="detail.sent">{{ (detail.sent ? 'email_sent' : 'email_not_sent') | translate }}</span>
    </div>

    <div class="detail-content">
      <div class="field-grid">
        <div class="field">
          <span class="field-label">{{ 'email_date' | translate }}</span>
          <span class="field-value">{{ detail.createDate | localizedDate: 'short' }}</span>
        </div>
        <div class="field">
          <span class="field-label">{{ 'email_reply_to' | translate }}</span>
          <span class="field-value">{{ detail.replyTo }}</span>
        </div>
      </div>

      <div class="send-error" *ngIf="!detail.sent && detail.errorMessage">{{ detail.errorMessage }}</div>

      <h5 class="section-title">{{ 'email_detail_recipients' | translate: { count: detail.recipients.length } }}</h5>
      <div class="recipients">
        <span class="recipient" *ngFor="let r of detail.recipients | slice: 0 : previewCount">{{ r }}</span>
      </div>
      <button type="button" class="see-all" mat-button color="primary" *ngIf="detail.recipients.length > previewCount" (click)="openAddressList('email_detail_recipients', detail.recipients)">
        {{ 'email_detail_see_all_recipients' | translate: { count: detail.recipients.length } }}
      </button>

      <div class="rejected" *ngIf="detail.rejectedRecipients.length">
        <span>{{ 'email_rejected_count' | translate: { count: detail.rejectedRecipients.length } }}</span>
        <button type="button" mat-button color="primary" (click)="openAddressList('email_rejected_count', detail.rejectedRecipients)">{{ 'email_see_list' | translate }}</button>
      </div>

      <h5 class="section-title">{{ 'email_detail_content' | translate }}</h5>
      <div class="mail-body" [innerHTML]="detail.body"></div>
    </div>
  </ng-container>

  <div class="detail-actions">
    <button type="button" mat-button (click)="onClose()">{{ 'common_btn_back' | translate }}</button>
  </div>
</div>

<ng-template #addressList>
  <div class="all-recipients">
    <h4 class="all-recipients-title">{{ listTitle | translate: { count: listAddresses.length } }}</h4>
    <ul class="all-recipients-list">
      <li *ngFor="let r of listAddresses">{{ r }}</li>
    </ul>
    <div class="detail-actions">
      <button type="button" mat-button (click)="listDialog?.close()">{{ 'common_btn_back' | translate }}</button>
    </div>
  </div>
</ng-template>
